import { Modal } from "react-bootstrap";
import styles from "./modal.module.css";
import { useState } from "react";
import { ApiClient } from "../../utils/apiClient";
import { useSelector } from "react-redux";
import { AppState } from "../../store/root.reducer";

interface ModalProps {
    show: boolean;
    onHide: () => void;
    onShared: (status: boolean) => void;
}

const BASE_API = process.env.REACT_APP_BASE_API;


export const FeedbackModal = ({show, onHide, onShared}: ModalProps) => {
    
    const apiClient = ApiClient(BASE_API);

    const user = useSelector((state: AppState) => state.auth.user)
    const [feedback, setFeedback] = useState<string>('');
    const onSubmit = async () => {
        const { status } = await apiClient.shareFeedabck(feedback, user ? user._id : undefined);
        onShared(status);
    }
    
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
        >
            <Modal.Header closeButton className={styles.background}>
                <Modal.Title id="contained-modal-title-vcenter">
                    SHARE FEEDBACK
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={styles.background}>
                <div className="p-3">
                    <textarea 
                        className="form-control" 
                        rows={10} 
                        value={feedback} 
                        onChange={e => setFeedback(e.target.value)} 
                        placeholder="Share your thoughts on what you like, dislike or would like to see on our platform.
                    You can also leave your email if you would like to get in touch with us."
                    />
                </div>
            </Modal.Body>
            <Modal.Footer className={styles.background}>
                <button className="btn btn-success" onClick={onHide}>
                    Close
                </button>
                <button
                    className="btn btn-success" 
                    onClick={onSubmit} 
                    // disabled={!user || !user?.roles.includes("BUYER") || artwork.owner === user?._id}
                >
                    Submit
                </button>
            </Modal.Footer>
        </Modal>
    )
}